import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { formatEtaFromDate } from "app/common/utils/date.util";
import { environment } from "environments/environment";
import { Observable, ReplaySubject, forkJoin, tap } from "rxjs";
import { IBidSubgraph, IKryptomonOrderSubgraph } from "../kryptomons/kryptomons.interface";
import { subgraphChainName } from "app/common/utils/subgraph.utils";
import { eNetworkName } from "../contract/contract.config";
import { Web3Service } from "../web3/web3.service";
import { UserService } from "../user/user.service";
import { kryptomonsAcceptedBidsQuery, kryptomonsOpenedBidsQuery, kryptomonsSoldQuery } from "../kryptomons/kryptomons.subgraph.query";

@Injectable({
    providedIn: 'root'
})
export class NotificationService {

    private _notificationItems: ReplaySubject<InotificationItem[]> = new ReplaySubject<InotificationItem[]>(1);
    private _numberUnreadNotification: ReplaySubject<number> = new ReplaySubject<number>(1);


    constructor(
        private http: HttpClient,
        private web3Service: Web3Service,
        private userService: UserService
    ) { }

    // checkNotification(): Observable<InotificationItem[]> {
    //     let now: number = new Date().valueOf(); //maybe in old FE there is a mistake, should be divided by 1000?
    //     let latestNotificationDateRead: number = parseInt((localStorage.getItem('last_notification') ? localStorage.getItem('last_notification') : '0'), 10);
    //     return this.http.get<InotificationItem[]>(environment.apiBaseUrl + 'notifications/retriveNotificationGrowth.php?timestamp=' + now)
    //         .pipe(tap(items => {
    //             items = items.map(item => { return { ...item, etaAgo: formatEtaFromDate(item.timestamp) } });
    //             this._notificationItems.next(items);
    //             this._numberUnreadNotification.next(items.filter(item => latestNotificationDateRead < item.timestamp).length);
    //         }
    //         ));
    // }

    checkNotification(): Observable<any> {
        let now: number = new Date().valueOf(); //maybe in old FE there is a mistake, should be divided by 1000?
        let latestNotificationDateRead: number = parseInt((localStorage.getItem('last_notification') ? localStorage.getItem('last_notification') : '0'), 10);
        return forkJoin([
            this.http.get<InotificationItem[]>(environment.apiBaseUrl + 'notifications/retriveNotificationGrowth.php?timestamp=' + now),
            this.getAcceptedBidSubgraph(),
            this.getOpenedBidSubgraph(),
            this.getkryptomonsSoldSubgraph()
        ]).pipe(tap(
            res => {
                let allNotification: InotificationItem[] = [
                    ...res[0].map(r => { return { ...r, urlTarget: '_blank' } }),
                    ...this.getBidsNotification(res[1].data.bids, 'sold'),
                    ...this.getBidsNotification(res[2].data.bids, 'open'),
                    ...this.getOrdersNotification(res[3].data.orders)
                ];
                allNotification = allNotification.map(item => { return { ...item, etaAgo: formatEtaFromDate(item.timestamp) } });
                allNotification = allNotification.sort((a, b) => b.timestamp - a.timestamp);
                this._notificationItems.next(allNotification);
                this._numberUnreadNotification.next(allNotification.filter(item => latestNotificationDateRead < item.timestamp).length);
            }
        ));
    }

    getAcceptedBidSubgraph(): Observable<{ data: { bids: IBidSubgraph[] } }> {
        let ownerWallet: string = this.userService._userInfoData.recordedWallet;
        let query: string = kryptomonsAcceptedBidsQuery(ownerWallet);
        let chainNameForSubgraph: string = subgraphChainName(this.web3Service.getNetworkName() as eNetworkName);
        return this.http.post<{ data: { bids: IBidSubgraph[] } }>(`${environment.subgraph + chainNameForSubgraph}/api`,
            { query })
    }

    getOpenedBidSubgraph(): Observable<{ data: { bids: IBidSubgraph[] } }> {
        let ownerWallet: string = this.userService._userInfoData.recordedWallet;
        let query: string = kryptomonsOpenedBidsQuery(ownerWallet);
        let chainNameForSubgraph: string = subgraphChainName(this.web3Service.getNetworkName() as eNetworkName);
        return this.http.post<{ data: { bids: IBidSubgraph[] } }>(`${environment.subgraph + chainNameForSubgraph}/api`,
            { query })
    }

    getkryptomonsSoldSubgraph(): Observable<{ data: { orders: IKryptomonOrderSubgraph[] } }> {
        let ownerWallet: string = this.userService._userInfoData.recordedWallet;
        let query: string = kryptomonsSoldQuery(ownerWallet);
        let chainNameForSubgraph: string = subgraphChainName(this.web3Service.getNetworkName() as eNetworkName);
        return this.http.post<{ data: { orders: IKryptomonOrderSubgraph[] } }>(`${environment.subgraph + chainNameForSubgraph}/api`,
            { query })
    }

    get notificationItems$(): Observable<InotificationItem[]> {
        return this._notificationItems.asObservable();
    }

    get numberUnreadNotification$(): Observable<number> {
        return this._numberUnreadNotification.asObservable();
    }

    setNotificationRead(): void {
        localStorage.setItem('last_notification', new Date().valueOf() / 1000 + '');
        this._numberUnreadNotification.next(0);
    }

    getBidsNotification(bids: IBidSubgraph[], type: | 'sold' | 'open'): InotificationItem[] {
        return bids.map(b => {
            let price: number = Math.round(this.web3Service.fromWeiFloat(b.price));
            return {
                title: type == 'open' ? 'Someone is interested in yours Kryptomon ' + b.tokenId :
                    'You won the kryptomon ' + b.tokenId,
                description: type == 'open' ? 'Someone has placed a bid of ' + price + 'KMON on your Kryptomon.' :
                    'Your bid of ' + price + 'KMON has been accepted',
                img_url: type == "open" ? './assets/img/notification/new-bid.png' :
                    './assets/img/notification/bid-accepted.png',
                redirect_url: '/kryptomons/' + b.tokenId,
                timestamp: parseInt(b.updatedAt),
                urlTarget: '_self'
            }
        });
    }

    getOrdersNotification(orders: IKryptomonOrderSubgraph[]): InotificationItem[] {
        return orders.map(o => {
            let price: number = Math.round(this.web3Service.fromWeiFloat(o.price));
            return {
                title: 'Someone has purchased the Kryptomon ' + o.tokenId + ' you had listed for sale.',
                description: 'Your Kryptomon has been purchased for: ' + price + '$',
                img_url: './assets/img/notification/sold.png',
                redirect_url: '/kryptomons/' + o.tokenId,
                timestamp: parseInt(o.updatedAt),
                urlTarget: '_self'
            }
        });
    }
}


export interface InotificationItem {
    title: string
    description: string
    img_url: string
    timestamp: number
    redirect_url: string
    etaAgo?: { value: number, text: string },
    urlTarget: '_blank' | '_self'
}
